import {registerPaymentMethod} from '@woocommerce/blocks-registry';
import {getSetting} from '@woocommerce/settings';
import {canMakePayment, LocalPaymentIntentContent} from './local-payment-method';
import {BNPLMessageLabel, PaymentMethod} from "@wc-stripe/blocks-components";

const data = getSetting('stripe_affirm_data');
const bnplData = getSetting('stripeBNPLCart_data');

if (data) {
    registerPaymentMethod({
        name: data.name,
        label: <BNPLMessageLabel
            data={bnplData}
            title={data.title}
            paymentMethod={data.name}
            icons={data.icon}
            paymentMethodTypes={['affirm']}/>,
        ariaLabel: 'Affirm',
        placeOrderButtonLabel: data.placeOrderButtonLabel,
        canMakePayment: canMakePayment(data.gatewayId),
        content: <PaymentMethod
            content={LocalPaymentIntentContent}
            data={data}/>,
        edit: <PaymentMethod content={LocalPaymentIntentContent} data={data}/>,
        supports: {
            showSavedCards: false,
            showSaveOption: false,
            features: data.features
        }
    })
}